import { ColumnType } from "../../types/dataGridTypes";

const studyListJson = (studyStatusOptions: any) => {
  const studyListColumns: ColumnType[] = [
    {
      field: "study_id",
      headerName: "Study ID",
      minWidth: 100,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
    },
    {
      field: "ind",
      headerName: "IND",
      width: 100,
      flex: 0.5,
      type: "number",
    },
    {
      field: "no_of_sites",
      headerName: "Sites",
      width: 100,
      filterable: false,
      sortable: false,
    },
    {
      field: "treatments",
      headerName: "Treatment",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "enrollment",
      headerName: "Enrollment",
      width: 100,
      type: "number",
    },
    {
      field: "study_status_value_code",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      type: "singleSelect",
      valueOptions: studyStatusOptions,
      cmp: "chip",
      isCodelistValue: true,
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];
  return studyListColumns;
};

export default studyListJson;
